import { FuseNavigation } from "@fuse";
import _ from "@lodash";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import classNames from "classnames";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";

class Navigation extends XAPPComponent {

    getNavigation = (_AEmpresa) => {
        const { navigation = null, user } = this.props;
        if (!_.isNull(navigation) && Object.keys(navigation).length > 0 && !_.isUndefined(navigation[_AEmpresa])) {
            let AJson = JSON.parse(JSON.stringify([navigation[_AEmpresa]]));
            AJson[0].children.push({ "id": "help", "title": "Ajuda", "type": "item", "url": "/help", "icon": "help", "children": [] });
            AJson[0].children.push({ "id": "meuperfil", "title": "Meu perfil", "type": "item", "url": "/conta/editarmeuperfil/" + user.idpessoa, "icon": "person", "children": [] });
            AJson[0].children.push({ "id": "sair", "title": "Sair", "type": "item", "url": "/pub-logout", "icon": "exit_to_app", "children": [] });
            return JSON.parse(Helpers.ReplaceAll(JSON.stringify(AJson), "<##DATA##>", Date.now()));
        }
        else {
            let AMenu = {
                id: "NotEmpresa",
                type: "group",
                icon: "menu",
                children: [],
            };
            AMenu.children.push({ "id": "meuperfil", "title": "Meu perfil", "type": "item", "url": "/conta/editarmeuperfil/" + user.idpessoa, "icon": "person", "children": [] });
            AMenu.children.push({ "id": "sair", "title": "Sair", "type": "item", "url": "/pub-logout", "icon": "exit_to_app", "children": [] });
            return [AMenu];
        }
    };

    render() {
        const { navigation, layout, dense, className, empresa } = this.props;

        return (
            navigation !== null &&
            <FuseNavigation
                className={classNames("navigation", className)}
                navigation={this.getNavigation(empresa)}
                layout={layout}
                dense={dense}
            />
        );
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        navigation: fuse.navigation.navigation,
        empresa: fuse.navigation.empresa,
        user: auth.user.data,
    };
}

Navigation.defaultProps = {
    layout: "vertical"
};

export default withRouter(connect(mapStateToProps)(Navigation));
